// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2iOyV","select":"Header_select__3jeZP","clinic":"Header_clinic__3ycsl"};